var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placementarea[data-v-5497906d]{width:100%;height:40px;background:#94b4eb;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-image:url(" + escape(require("../../../../../static/obliqueLine.png")) + ");background-size:50%,100%;-webkit-transition:all .5s;transition:all .5s}.placementarea span[data-v-5497906d]{color:#fff;display:inline-block;width:140px;height:25px;font-size:12px;text-align:center;line-height:25px;background:#5487df}", ""]);

// exports
